import React from "react";
import OfferCard from "./OfferCard";
import "./OfferView.css";

const OfferView = ({ cards = [] }) => {
  return (
    <div className="offer-view">
      <div className="offer-cards-container">
        {cards.map((card, index) => (
          <OfferCard
            key={index}
            title={card.title}
            price={card.price}
            color={card.color}
            props={card.props}
            btnText={card.btnText}
            pausedInfo={card.pausedInfo}
            onClick={card.onClick}
            selected={card.selected}
            paymentType={card.paymentType}
            btnDisabled={card.btnDisabled}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default OfferView;
